import classNames from "classnames";
import Styles from "./Story.module.scss";
import Footer from "../../Component/Footer/Footer";
import Jumbotron from "../../Component/Jumbotron/Jumbotron";
import Navbar from "../../Component/Navbar/Navbar";
import img1 from "../../assets/images/index/加入我們.jpg"

const TheirStory = () => {
  return (
    <div>
      <Navbar />
      <div
        className={classNames("container", Styles.story)}
        style={{ paddingTop: "8vh" }}
      >
        <div>
          <div className={classNames("col-12", Styles.story__img__wrapper)}>
            <img
              src={img1}
              alt="加入我們.jpg"
            />
          </div>
          <p className={classNames(Styles.story__description)}> 
            每一段故事，都是一顆正在萌芽的種子。 <br/>我們正在細心傾聽與整理，
            很快就會與你分享這些動人的時刻。
          </p>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default TheirStory;
